var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header"},[_c('div',{staticClass:"content"},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.title)+" ")])],2),_c('div',{staticClass:"divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }